// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b85c4d6a","455":"01c54dcb","977":"955ba1ee"}[chunkId] + ".chunk.js";
};